<div class="app">
  <app-navigation></app-navigation>
  <router-outlet></router-outlet>
</div>
